import { render, staticRenderFns } from "./dictionaryselect.vue?vue&type=template&id=51ae1817"
import script from "./dictionaryselect.vue?vue&type=script&lang=js"
export * from "./dictionaryselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports